export default __webpack_public_path__ + "static/media/GALERIA_construyendo el futuro.e516ac84.mp4";